import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MegaMenu from "../MegaMenu/MegaMenu";
import { SERVICES } from "../../data/services";
import { PROJECTS } from "../../data/projects";
import "./Navbar.css";
import { useTranslation } from "react-i18next";

function Navbar() {

  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "hi" : "en";
    i18n.changeLanguage(newLang);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mega, setMega] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); setMega(null); }, [location]);

  const go = (path) => { navigate(path); setMobileOpen(false); setMega(null); };
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>

      {/* Logo */}
      <div className="navbar__logo" onClick={() => go("/")}>
        <div className="navbar__logo-mark">
          <img src="/sk.png" alt="SK Associate" className="navbar__logo-img" />
        </div>
        <div>
          <p className="navbar__brand">SK ASSOCIATE</p>
          <p className="navbar__tagline">CONCRETE FLOOR SOLUTIONS</p>
        </div>
      </div>

      {/* Desktop Links */}
      <div className="navbar__links">

        <button className={`nav-link ${location.pathname === "/" ? "nav-link--active" : ""}`} onClick={() => go("/")}>
          {t("home")}
        </button>

        <button className={`nav-link ${isActive("/about") ? "nav-link--active" : ""}`} onClick={() => go("/about")}>
          {t("about")}
        </button>

        {/* Services */}
        <div
          className="nav-dropdown"
          onMouseEnter={() => setMega("services")}
          onMouseLeave={() => setMega(null)}
        >
          <button
            className={`nav-link ${isActive("/services") ? "nav-link--active" : ""}`}
            onClick={() => go("/services")}
          >
            {t("services")} <span className="nav-arrow">▾</span>
          </button>

          {mega === "services" && (
            <MegaMenu
              items={SERVICES}
              basePath="/services"
              columns={3}
              heading={t("services_section.title")}
              onClose={() => setMega(null)}
            />
          )}
        </div>

        {/* Projects */}
        <div
          className="nav-dropdown nav-dropdown--right"
          onMouseEnter={() => setMega("projects")}
          onMouseLeave={() => setMega(null)}
        >
          <button
            className={`nav-link ${isActive("/projects") ? "nav-link--active" : ""}`}
            onClick={() => go("/projects")}
          >
            {t("projects")} <span className="nav-arrow">▾</span>
          </button>

          {mega === "projects" && (
            <div style={{ position: "absolute", top: "100%", right: 0, zIndex: 200 }}>
              <MegaMenu
                items={PROJECTS}
                basePath="/projects"
                columns={2}
                heading={t("projects_section.title")}
                onClose={() => setMega(null)}
              />
            </div>
          )}
        </div>

        <button className={`nav-link ${isActive("/contact") ? "nav-link--active" : ""}`} onClick={() => go("/contact")}>
          {t("contact")}
        </button>

        {/* Language Button */}
        <button className="navbar__lang-desktop" onClick={toggleLanguage}>
          {i18n.language === "en" ? "हिंदी" : "English"}
        </button>

        <button className="navbar__cta" onClick={() => go("/contact")}>
          GET QUOTE
        </button>
      </div>

      {/* Mobile Actions */}
      <div className="navbar__mobile-actions">
        <button className="navbar__lang-mobile" onClick={toggleLanguage}>
          {i18n.language === "en" ? "हिंदी" : "English"}
        </button>
        <button className="navbar__burger" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="navbar__mobile">
          {[
            ["/", t("home")],
            ["/about", t("about")],
            ["/services", t("services")],
            ["/projects", t("projects")],
            ["/contact", t("contact")],
          ].map(([path, label]) => (
            <div key={path} className="navbar__mobile-link" onClick={() => go(path)}>
              {label}
            </div>
          ))}
        </div>
      )}

    </nav>
  );
}

export default Navbar;